var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 892"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 259",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "url(#paint0_linear_21169_182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 386 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2481 7.83205L12.2859 22.7753L5.99658 17.1149L8.00348 14.8851L11.7141 18.2247L19.752 6.16795L22.2481 7.83205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21169_182",
    x1: 13.5,
    y1: 0,
    x2: 13.5,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.9e8e9496763841587de03f4c96b91214.svg";
export { ForwardRef as ReactComponent };